module.exports = __webpack_public_path__ + "static/media/platform_mobile.cd80d8da.svg";